import * as React from 'react';
const SvgHamburger = (props) => (
    <svg
        fill='none'
        height={30}
        width={30}
        viewBox='0 0 20 20'
        xmlns='http://www.w3.org/2000/svg'
        {...props}>
        <g>
            <path
                fill='currentColor'
                d='M3.958 14.196a.53.53 0 0 1-.385-.155.52.52 0 0 1-.156-.383q0-.228.156-.387a.52.52 0 0 1 .385-.159h12.084a.526.526 0 0 1 .541.538.53.53 0 0 1-.155.387.52.52 0 0 1-.386.158zm0-3.654a.53.53 0 0 1-.385-.155.52.52 0 0 1-.156-.383q0-.228.156-.387a.52.52 0 0 1 .385-.159h12.084q.23 0 .386.155.156.154.155.383a.53.53 0 0 1-.155.387.52.52 0 0 1-.386.159zm0-3.654a.526.526 0 0 1-.541-.538q0-.227.156-.387a.52.52 0 0 1 .385-.158h12.084a.526.526 0 0 1 .541.537.53.53 0 0 1-.155.387.52.52 0 0 1-.386.159z' />
        </g>
    </svg>
);
export default SvgHamburger;
